import React from 'react';

interface StampProps {
  variant?: 'verified' | 'selfrep';
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const Stamp: React.FC<StampProps> = ({ variant = 'verified', children, style }) => (
  <span className={`stamp ${variant}`} style={style}>
    <span className="dot"></span>
    {children}
  </span>
);

export default Stamp;
